import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    padding: theme.spacing(2),
    '&:first-child': {
      borderTop: [1, 'solid', theme.palette.colors.divider],
    },
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'unset',
      padding: theme.spacing(4),
    },
    height: 110,
  },
  avatar: {
    marginLeft: theme.spacing(2),
  },
  mainBox: {
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerInfo: {
    width: 120,
  },
  loanOfficerBadge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 120,
    marginLeft: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      width: 150,
    },
  },
  name: {
    marginTop: 4,
  },
  infoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: 350,
  },
  label: {
    color: theme.palette.colors.darkBlueGray,
    marginTop: 4,
  },
  companyLogo: {
    height: 30,
    width: 'auto',
    maxWidth: 100,
    marginRight: theme.spacing(2),
  },
  locationBadge: {
    width: 200,
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/FavoriteLoanOfficersList/components/LoanOfficerCard/useStyles.js